import React from "react";
import { useSelector } from "react-redux";

const CircularProgress = ({ percentage, label, total }) => {
  const formattedPercentage = percentage.toFixed(2);
  return (
    <div className="flex flex-col items-center">
      <div className="relative w-36 h-36">
        <svg className="transform -rotate-90 w-full h-full" viewBox="0 0 36 36">
          <circle
            className="text-slate-200"
            stroke="currentColor"
            fill="transparent"
            strokeWidth="4"
            strokeDasharray="100, 100"
            cx="18"
            cy="18"
            r="15.915"
          />
          <circle
            className="text-blue-600"
            stroke="currentColor"
            fill="transparent"
            strokeWidth="4"
            strokeDasharray={`${formattedPercentage}, 100`}
            cx="18"
            cy="18"
            r="15.915"
          />
        </svg>
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="text-lg font-semibold text-slate-800">
            {formattedPercentage}%
          </span>
        </div>
      </div>
      <span className="text-slate-700 font-medium text-base mt-2">
        {label}: <span className="text-slate-500">{total}</span>
      </span>
    </div>
  );
};

const InspectionBreakdown = () => {
  const { dashboardRejectionBreakCount } = useSelector(
    (state) => state.dashboard,
  );
  if (
    !dashboardRejectionBreakCount ||
    dashboardRejectionBreakCount.length === 0
  ) {
    return <div>No data available</div>;
  }

  const totalCount = dashboardRejectionBreakCount[0]?.total[0]?.count || 0;
  const odOnlyCount =
    dashboardRejectionBreakCount[0]?.data.find((item) => item.ins_type === "OD")
      ?.count || 0;
  const odIdCount =
    dashboardRejectionBreakCount[0]?.data.find(
      (item) => item.ins_type === "ID & OD",
    )?.count || 0;

  const NACount =
    dashboardRejectionBreakCount[0]?.data.find(
      (item) => item.ins_type === "N/A",
    )?.count || 0;

  const odOnlyPercentage =
    totalCount > 0 ? (odOnlyCount / totalCount) * 100 : 0;
  const odIdPercentage = totalCount > 0 ? (odIdCount / totalCount) * 100 : 0;
  const naPercentage = totalCount > 0 ? (NACount / totalCount) * 100 : 0;
  const totalPercentage = 100;
  return (
    <div className="bg-white border border-slate-200 shadow-sm rounded-xl">
      <div className="text-xl font-semibold p-5 text-slate-800">
        Inspection Breakdown
      </div>
      <div className="flex flex-col items-center p-4 md:flex-row md:justify-around">
        <CircularProgress
          percentage={totalPercentage}
          label="Total"
          total={totalCount}
        />
        <CircularProgress
          percentage={odOnlyPercentage}
          label="OD Only"
          total={odOnlyCount}
        />
        <CircularProgress
          percentage={odIdPercentage}
          label="OD + ID"
          total={odIdCount}
        />
        <CircularProgress
          percentage={naPercentage}
          label="NA"
          total={NACount}
        />
      </div>
    </div>
  );
};
export default InspectionBreakdown;
